import React from "react";
import styles from "./ActionButton.module.scss";
import {
  FiCheckCircle,
  FiEdit3,
  FiEye,
  FiLayers,
  FiPlusCircle,
  FiSave,
  FiTrash,
  FiXCircle,
  FiMapPin
} from "react-icons/fi";

const ActionButton = ({ btnType, onClick, label }) => {
  switch (btnType) {
    case "edit":
      return (
        <button onClick={onClick} className={styles.btnEdit}>
          <FiEdit3 size={16} />
          <span>{label || "Edit"}</span>
        </button>
      );
    case "kinerja":
      return (
        <button onClick={onClick} className={styles.btnKinerja}>
          <FiPlusCircle size={16} />
          <span>Tambah Kinerja</span>
        </button>
      );
    case "delete":
      return (
        <button onClick={onClick} className={styles.btnDelete}>
          <FiTrash size={16} />
          <span>Hapus</span>
        </button>
      );
    case "approve":
      return (
        <button onClick={onClick} className={styles.btnKinerja}>
          <FiCheckCircle size={16} />
          <span>Terima</span>
        </button>
      );
    case "reject":
      return (
        <button onClick={onClick} className={styles.btnDelete}>
          <FiXCircle size={16} />
          <span>Tolak</span>
        </button>
      );
    case "detail":
      return (
        <button onClick={onClick} className={styles.btnDetail}>
          <FiEye size={16} />
          <span>Lihat</span>
        </button>
      );
    case "doseBand":
      return (
        <button onClick={onClick} className={styles.btnDoseBand}>
          <FiLayers size={16} />
          <span>{label || "Dosis standar"}</span>
        </button>
      );
    case "intervensi":
      return (
        <button onClick={onClick} className={styles.btnKinerja}>
          <FiPlusCircle size={16} />
          <span>{label || "Kohort"}</span>
        </button>
      );
    case "map":
      return (
        <button onClick={onClick} className={styles.btnDetail}>
          <FiMapPin size={16} />
          <span>{label || "QR Maps"}</span>
        </button>
      );
    case "save":
      return (
        <button onClick={onClick} className={styles.btnDetail}>
          <FiSave size={16} />
          <span>Simpan</span>
        </button>
      );
    case "cancel":
      return (
        <button onClick={onClick} className={styles.btnDelete}>
          <FiXCircle size={16} />
          <span>Batal</span>
        </button>
      );
    case "kirim":
      return (
        <button onClick={onClick} className={styles.btnKirim}>
          <FiEdit3 size={16} />
          <span>{label || "Kirim"}</span>
        </button>
      );
    default:
      return null;
  }
};

export default ActionButton;
